export default __webpack_public_path__ + "static/media/Reader's Boots of the Celestial Hilt.fd7b7a21.jpg";